import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";

import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

/**
 * Section containing fields that only appear when editing an existing PCM:
 * - Deadline (date picker)
 * - Update (textarea for notes to customer)
 * - Send Response (checkbox to share update with customer)
 */
const PcmEditFieldsSection = withForm({
  defaultValues: pcmFormDefaultValues,
  render: function Render({ form }) {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          PCM UPDATE
        </Typography>
        <Box sx={{ border: 1, borderColor: "divider", p: 3, borderRadius: 1 }}>
          {/* Deadline */}
          <Box sx={{ mb: 3 }}>
            <form.AppField name="deadline">
              {(field) => (
                <field.TextInput
                  label="Deadline"
                  type="date"
                  size="small"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            </form.AppField>
          </Box>

          {/* Update/Note */}
          <Box sx={{ mb: 2 }}>
            <form.AppField name="update">
              {(field) => (
                <field.TextInput
                  label="Update"
                  multiline
                  rows={5}
                  placeholder="Enter update notes for this PCM..."
                />
              )}
            </form.AppField>
          </Box>

          {/* Send Response Checkbox */}
          <form.AppField name="send_response">
            {(field) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.state.value ?? false}
                    onChange={(e) => field.handleChange(e.target.checked)}
                  />
                }
                label="Click this box to send the note as a response to the customer."
              />
            )}
          </form.AppField>
        </Box>
      </Box>
    );
  },
});

export default PcmEditFieldsSection;
